var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EEF8F1",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M21.833 8.5h-7.777c-.541 0-1.068.176-1.5.5L9.5 11.292c-.63.472-1 1.213-1 2v8.541c0 .921.746 1.667 1.667 1.667h8.75c.786 0 1.527-.37 2-1l2.25-3c.216-.288.333-.64.333-1v-8.333c0-.921-.746-1.667-1.667-1.667v0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m20.164 12.091 3.033-2.866M20.167 23.159V12.091M20.17 12.091H8.82M14.633 12.092 18.74 8.5M12.664 15.167h3.333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommType);
export default __webpack_public_path__ + "static/media/comm-type.3171c21870a5c42c4380c8e177c8f028.svg";
export { ForwardRef as ReactComponent };